import { DestroyRef, Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { tap } from 'rxjs';
import { AccessControlScope, AclWithScope } from '@/core/types/security/acl';
import { AclService } from '@/core/services/security/acl.service';
import { SecurityService } from '@/core/services/security/security.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[aclSome], [aclEvery], [acl], [aclWithScope]',
    standalone: true
})
export class AclDirective {
    private _scope: AccessControlScope = 'all';

    constructor(
        private aclService: AclService,
        private security: SecurityService,
        private viewContainerRef: ViewContainerRef,
        private templateRef: TemplateRef<unknown>,
        private destroyRef: DestroyRef
    ) {
        this.aclService.dataChange$
            .pipe(
                tap(() => this.update),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe();
        this.security.meChange$
            .pipe(
                tap(() => this.update),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe();
    }

    private _acl?: string[];

    @Input() set acl(value: string | string[]) {
        this.aclEvery = typeof value === 'string' ? [value] : value;
    }

    @Input() set aclWithScope(value: AclWithScope) {
        this._acl = value?.acl;
        this._scope = value?.scope;
        this.update();
    }

    @Input() set aclEvery(value: string[]) {
        this.aclWithScope = { scope: 'all', acl: value };
    }

    @Input() set aclSome(value: string[]) {
        this.aclWithScope = { scope: 'any', acl: value };
    }

    private update() {
        if (!this._scope) {
            this.updateContainer(true);
            return;
        }
        if (!this._acl || this._acl.length === 0 || !this.aclService.data) {
            return;
        }
        this.aclService.validateAcl(this._acl);
        this.updateContainer(this.security.hasEnoughAccess(this._acl, this._scope));
    }

    private updateContainer(accessible: boolean) {
        if (accessible) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainerRef.clear();
        }
    }
}
